var map = {
	"./bn.json": [
		9082,
		82
	],
	"./en.json": [
		1700
	],
	"./hi.json": [
		866,
		866
	],
	"./ma.json": [
		6917,
		917
	],
	"./ta.json": [
		4028,
		28
	],
	"./te.json": [
		244,
		244
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7875;
module.exports = webpackAsyncContext;